import { Grid, withStyles } from '@material-ui/core';
import RouteMap from './RouteMap';
import RouteKPI from './RouteKPI';
import RouteImages from './RouteImages';

const styles = (theme) => ({
  fullHeight: { height: '100%' },
  viewContainer: {
    height: '100%',
    display: 'block',
    margin: 0
  }
});

const RouteDetails = ({ driverData, classes, route, glEventHub }) => {
  return (
    <Grid container spacing={24} className={classes.fullHeight}>
      <Grid item xs={5} className={classes.viewContainer}>
        <RouteKPI route={route} />
        <RouteImages driverData={driverData} />
      </Grid>
      <Grid item xs={7}>
        <RouteMap driverData={driverData} classes={classes} route={route} glEventHub={glEventHub} />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(RouteDetails);
